import React from "react";
import { useNavigate } from "react-router-dom";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex items-center justify-center px-6" data-testid="payment-cancel-page">
      <div className="tome-card max-w-lg w-full rounded-sm p-8 text-center space-y-5">
        <div className="font-mono text-[0.6rem] uppercase tracking-[0.4em] gold">Rite Aborted</div>
        <div className="font-serif-display text-2xl">The Covenant remains unsealed</div>
        <p className="font-prose text-stone-300">You may ascend at any time. The archive is patient.</p>
        <button data-testid="cancel-return" onClick={() => navigate("/app")} className="btn-gold">Return to the Vault</button>
      </div>
    </div>
  );
}
